import React from 'react';
export function HeroSection() {
  return <section id="hero-section" className="relative w-full flex flex-col text-center px-4 pt-6 pb-8 sm:pt-12 sm:pb-20 items-center justify-center bg-bg-main overflow-hidden" data-id="element-146">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(234,88,12,0.15) 0%, transparent 70%)'
    }} aria-hidden="true" data-id="element-147"></div>

      <div className="relative bg-badge-red/10 border border-badge-red/20 text-badge-red font-bold text-[10px] sm:text-xs px-3 py-1 sm:px-4 sm:py-1.5 rounded-full mb-4 sm:mb-6 flex items-center gap-1.5 sm:gap-2" data-id="element-148">
        <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-badge-red animate-pulse-composited" data-id="element-149"></span>
        <span className="hidden sm:inline" data-id="element-150">
          ATTENZIONE: DOCENTI DI SCUOLA SECONDARIA STANCHI DI SACRIFICARE LE
          PROPRIE SERATE A PIANIFICARE
        </span>
        <span className="sm:hidden" data-id="element-151">
          ATTENZIONE: DOCENTI DI SCUOLA SECONDARIA
        </span>
      </div>

      <h1 className="relative font-black text-text-main max-w-5xl sm:text-5xl md:text-6xl sm:leading-[1.1] mb-4 sm:mb-6 tracking-tight text-[28px] leading-[1.15]" data-id="element-152">
        Tutto l'anno di{' '}
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-orange-400" data-id="element-153">
          ARTE SECONDARIA
        </span>{' '}
        pronto in 5 minuti.
      </h1>

      <p className="relative text-text-sec text-sm sm:text-xl font-medium leading-relaxed mb-4 sm:mb-8 max-w-3xl mx-auto sm:bg-bg-alt sm:border sm:border-white/10 sm:border-l-4 sm:border-l-primary sm:px-8 sm:py-5 sm:rounded-r-xl sm:text-left" data-id="element-154">
        Il primo Kit{' '}
        <span className="text-orange-400 font-bold" data-id="element-155">"Apri e Insegna"</span> con
        6 volumi completi e lezioni pronte per Medie e Superiori.{' '}
        <span className="hidden sm:inline text-text-main font-semibold" data-id="element-156">
          Recupera i tuoi weekend e stupisci i tuoi alunni.
        </span>
      </p>

      <div className="relative w-full max-w-[260px] sm:max-w-[420px] md:max-w-[500px] mx-auto mb-4 sm:mb-8" data-id="element-157">
        <div className="absolute inset-0 rounded-full pointer-events-none" style={{
        background: 'radial-gradient(circle, rgba(234,88,12,0.15) 0%, transparent 70%)'
      }} aria-hidden="true" data-id="element-158"></div>
        <img src="https://cdn.magicpatterns.com/uploads/5fU4zPscgeWSJWWS37QQSw/1500-CLIENTE-SODDISFATTI-_1_.webp" alt="Arte Pronta — Kit Scuola Secondaria" className="relative w-full h-auto object-contain rounded-2xl" width={500} height={500} sizes="(max-width: 640px) 260px, (max-width: 768px) 420px, 500px" fetchPriority="high" data-id="element-159" />
      </div>

      <div className="relative flex flex-col items-center gap-2 sm:gap-2 mb-4 sm:mb-6" data-id="element-160">
        <div className="flex items-center gap-2" data-id="element-161">
          <span className="text-secondary text-sm sm:text-lg" data-id="element-162">⭐⭐⭐⭐⭐</span>
          <span className="text-text-sec text-xs sm:text-base font-medium" data-id="element-163">
            4.9/5 (+500 Recensioni Verificate)
          </span>
        </div>
        <span className="text-secondary font-bold text-xs sm:text-sm bg-secondary/10 px-3 py-1 rounded-full border border-secondary/20" data-id="element-164">
          🔥 62 insegnanti hanno scelto questo Kit oggi
        </span>
      </div>

      <a href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-base sm:text-2xl px-6 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-colors inline-block mb-3 sm:mb-4 w-full sm:w-auto max-w-xl text-gray-900 shadow-[0_0_30px_rgba(16,185,129,0.3)] border border-white/10" data-id="element-165">
        🚀 SÌ! VOGLIO RECUPERARE IL MIO TEMPO
      </a>

      <p className="relative text-text-sec text-[11px] sm:text-sm font-medium flex items-center justify-center gap-1.5 sm:gap-2 flex-wrap" data-id="element-166">
        <span data-id="element-167">⚡ Accesso Immediato</span>
        <span data-id="element-168">•</span>
        <span data-id="element-169">🛡️ Garanzia 7 Giorni</span>
        <span data-id="element-170">•</span>
        <span data-id="element-171">💳 Pagamento Unico</span>
      </p>
    </section>;
}